module.exports = __webpack_public_path__ + "img/5C.b8fab0f2.svg";